
import { mapGetters } from 'vuex'

import Currency from '~/mixins/Currency.js'
import ProductNumber from '~/mixins/ProductNumber.js'

export default {
  mixins: [Currency, ProductNumber],

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters('cart', ['cart']),
    ...mapGetters('favorites', ['favorites']),

    productPrice() {
      return this.$auth.$state.priceInclTax
        ? this.product.gross_price
        : this.product.price
    },

    isFavorite() {
      return this.favorites?.items?.some(
        (favorite) => favorite.product_nr === this.product.product_nr
      )
    },

    onlyBusiness() {
      const businessProduct = this.product.is_business

      const privateCustomer = this.$auth.$state.user?.customerType === 'private'

      return businessProduct && privateCustomer
    },
  },

  methods: {
    async addToCart() {
      if (!this.cart.items) {
        await this.$store.dispatch('cart/getCart')
      }

      await this.$store.dispatch('cart/incrementQuantity', this.product.id)
    },

    async toggleFavorite(isFavorite) {
      if (isFavorite) {
        await this.$store.dispatch(
          'favorites/removeFromFavorites',
          this.product.id
        )
      } else {
        await this.$store.dispatch('favorites/addToFavorites', this.product.id)
        this.$store.commit('favorites/setOpen')
      }
    },
  },
}
